











import { Component, mixins, namespace } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { IHeaderBanner } from '~/assets/interfaces/site'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentHeaderBanner: () =>
      import('~/components/header/header-banner.vue'),
    ComponentHeaderVariant1: () =>
      import('~/components/header/variants/header-variant-1.vue'),
    ComponentHeaderVariant2: () =>
      import('~/components/header/variants/header-variant-2.vue'),
    ComponentHeaderVariant3: () =>
      import('~/components/header/variants/header-variant-3.vue'),
    ComponentHeaderVariant4: () =>
      import('~/components/header/variants/header-variant-4.vue'),
    ComponentHeaderVariant5: () =>
      import('~/components/header/variants/header-variant-5.vue'),
    ComponentHeaderVariant6: () =>
      import('~/components/header/variants/header-variant-6.vue'),
    ComponentHeaderVariant7: () =>
      import('~/components/header/variants/header-variant-7.vue'),
    ComponentHeaderVariant8: () =>
      import('~/components/header/variants/header-variant-8.vue'),
    ComponentHeaderVariant9: () =>
      import('~/components/header/variants/header-variant-9.vue'),
    ComponentHeaderVariant10: () =>
      import('~/components/header/variants/header-variant-10.vue'),
    ComponentHeaderVariant11: () =>
      import('~/components/header/variants/header-variant-11.vue'),
    ComponentHeaderVariant12: () =>
      import('~/components/header/variants/header-variant-12.vue'),
  },
})
export default class componentHeader extends mixins(MixinGeneral) {
  @siteStore.State('headerBanner') readonly headerBanner!: IHeaderBanner | null
  @siteStore.Getter('getLayoutHeaderNumber') readonly layoutHeaderNumber!:
    | number
    | null

  private get componentHeader() {
    switch (this.layoutHeaderNumber) {
      case 1: // !colored && notFixed && headerType1
        return 'component-header-variant1' // 'NN1'
      case 2: // colored && notFixed && headerType1
        return 'component-header-variant2' // 'CN1'
      case 3: // !colored && notFixed && headerType2
        return 'component-header-variant3' // 'NN2'
      case 4: // colored && notFixed && headerType2
        return 'component-header-variant4' // 'CN2'
      case 5: // !colored && mainLineFixed && headerType1
        return 'component-header-variant5' // 'NM1'
      case 6: // colored && mainLineFixed && headerType1
        return 'component-header-variant6' // 'CM1'
      case 7: // !colored && mainLineFixed && headerType2
        return 'component-header-variant7' // 'NM2'
      case 8: // colored && mainLineFixed && headerType2
        return 'component-header-variant8' // 'CM2'
      case 9: // !colored && fullLineFixed && headerType1
        return 'component-header-variant9' // 'NF1'
      case 10: // colored && fullLineFixed && headerType1
        return 'component-header-variant10' // 'CF1'
      case 11: // !colored && fullLineFixed && headerType2
        return 'component-header-variant11' // 'NF2'
      case 12: // colored && fullLineFixed && headerType2
        return 'component-header-variant12' // 'CF2'
      case null:
        return 'component-header-variant1' // 'NN1'
      default:
        return 'component-header-variant1' // 'NN1'
    }
  }
}
